export default __webpack_public_path__ + "static/media/checked2.f36694ac.svg";